import create from "zustand"

export type PaymentType = {
	id: number,
	name: string,
	user_id: number,
	account_number: string,
	account_holder: string,
	bank_id: string,
}

type PaymentStoreType = {
	paymentList: PaymentType[] | null
	setPaymentList: (list: PaymentType[]) => void
	addPayment: (payment: PaymentType) => void
	updatePayment: (payment: PaymentType) => void
	deletePayment: (id: number) => void

	selectedPayment: PaymentType | null
	setSelectedPayment: (payment: PaymentType | null) => void

	paymentFee: number
	setPaymentFee: (fee: number) => void
}

export const usePaymentStore = create<PaymentStoreType>((set) => ({
	paymentList: null,
	setPaymentList: (paymentList: PaymentType[]) => set(() => ({ paymentList })),
	addPayment: (payment: PaymentType) => set(({ paymentList }) => {
		set(() => ({ paymentList: [...(paymentList || []), payment] }))
	}),
	updatePayment: (payment: PaymentType) => set(({ paymentList }) => {
		const newList = (paymentList || []).map(item => {
			if (item.id !== payment.id) return item
			return payment
		})
		set(() => ({ paymentList: newList }))
	}),
	deletePayment: (id: number) => set(({ paymentList }) => {
		set(() => ({ paymentList: (paymentList || [])?.filter(item => item.id !== id) }))
	}),

	selectedPayment: null,
	setSelectedPayment: (payment: PaymentType | null) => set(() => ({ selectedPayment: payment })),

	paymentFee: 0,
	setPaymentFee: (fee: number) => set(() => ({ paymentFee: fee }))
}))
